var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C34.1608 0 41.0284 2.84464 46.0919 7.90812C51.1554 12.9716 54 19.8392 54 27C54 41.9117 41.9117 54 27 54ZM29.7 29.7047V13.5047C29.7 12.0135 28.4912 10.8047 27 10.8047C25.5088 10.8047 24.3 12.0135 24.3 13.5047V29.7047C24.3 31.1959 25.5088 32.4047 27 32.4047C28.4912 32.4047 29.7 31.1959 29.7 29.7047ZM28.026 38.024C28.1981 38.0831 28.3615 38.1648 28.512 38.267C28.6535 38.3667 28.7887 38.4749 28.917 38.591C29.4104 39.1084 29.6901 39.7931 29.7 40.508C29.7042 41.2256 29.4224 41.9154 28.917 42.425C28.6546 42.6635 28.3532 42.8552 28.026 42.992C27.3725 43.2808 26.6276 43.2808 25.974 42.992C25.6468 42.8552 25.3455 42.6635 25.083 42.425C24.5776 41.9154 24.2959 41.2256 24.3 40.508C24.2959 39.7903 24.5776 39.1005 25.083 38.591C25.7213 37.9589 26.6322 37.6856 27.513 37.862C27.6919 37.887 27.8653 37.9418 28.026 38.024ZM26.9953 5.39531C38.9247 5.39531 48.5953 15.066 48.5953 26.9953C48.5953 32.724 46.3196 38.218 42.2688 42.2688C38.218 46.3196 32.724 48.5953 26.9953 48.5953C15.066 48.5953 5.39531 38.9247 5.39531 26.9953C5.39531 15.066 15.066 5.39531 26.9953 5.39531Z",
    fill: "#D41111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alertRed.8d52e902.svg";
export { ForwardRef as ReactComponent };